var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/ArchivesCollections/ArchivesCollections.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/ArchivesCollections/ArchivesCollections.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "downloads"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("downloads", Object.prototype.hasOwnProperty.call(kwargs, "downloads") ? kwargs["downloads"] : runtime.contextOrFrameLookup(context, frame, "True"));var t_5 = "";t_5 += "\n    <div class=\"ArchivesCollections\">\n        <h2>Collections</h2>\n        <div class=\"ArchivesCollections-info\">";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"text")), env.opts.autoescape);
t_5 += "</div>\n\n        <div class=\"ArchivesCollections-wrapper\">\n            ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("collection", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                <div class=\"ArchivesCollections-block\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\">\n                    <div class=\"ArchivesCollections-blockTitle\">\n                        <h3>";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"title")), env.opts.autoescape);
t_5 += "</h3>\n                        <div class=\"ArchivesCollections-blockCrossWrapper\">\n                            <div class=\"ArchivesCollections-blockCrossTable\">\n                                <div class=\"ArchivesCollections-blockCrossCell\">\n                                    <div class=\"ArchivesCollections-blockCross\">\n                                        <div class=\"ArchivesCollections-blockCrossV\"></div>\n                                        <div class=\"ArchivesCollections-blockCrossH\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"ArchivesCollections-blockRolled\">\n                        <div>";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"content_rendered")), env.opts.autoescape);
t_5 += "</div>\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "downloads") && runtime.memberLookup((t_9),"download")) {
t_5 += "<a href=\"";
t_5 += runtime.suppressValue((lineno = 27, colno = 61, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((t_9),"download")),"url"), "collection[\"download\"][\"url\"]", context, [])), env.opts.autoescape);
t_5 += "\" class=\"ArchivesCollections-blockPdf\">Download PDF</a>\n                        ";
;
}
t_5 += "</div>\n                </div>\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("ArchivesCollections");
context.setVariable("ArchivesCollections", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/ArchivesCollections/ArchivesCollections.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArchivesCollections/ArchivesCollections.jinja
// module id = 473
// module chunks = 0